export function getPrimaryParticipantColumnLabel(
  isBay6: boolean,
  usePrimaryBehavioralTechnicianLabel: boolean,
): string {
  if (isBay6) {
    return 'Provider';
  }

  return usePrimaryBehavioralTechnicianLabel
    ? 'Primary Behavioral Technician'
    : 'Behavioral Technician';
}
